// 로그인 유도 카드. 로그인 후 원래 가던 경로로 돌아가게 pendingRoute를
// state에 저장한 뒤 PIN 로그인 화면으로 보낸다. 통계 탭 전용 변형은
// 자주 쓰여서 가벼운 wrapper로 별도 export.

import { navigate } from "../routes";
import { state } from "../state";
import { mountPreact } from "./preact-mount";

export interface LoginCtaOptions {
  title: string;
  hint: string;
  pendingRoute?: any;
}

function LoginCTA({ title, hint, pendingRoute }: LoginCtaOptions) {
  return (
    <div class="section section--panel">
      <div class="section__title"><h3>{title}</h3></div>
      <p class="menu__hint">{hint}</p>
      <button
        class="btn btn--primary btn--block"
        type="button"
        style="margin-top: 12px;"
        onClick={() => {
          if (pendingRoute) state.pendingRoute = pendingRoute;
          navigate({ name: "member_login" });
        }}
      >
        회원 PIN으로 로그인
      </button>
    </div>
  );
}

export function buildLoginCTA(opts: LoginCtaOptions): HTMLElement {
  return mountPreact(<LoginCTA {...opts} />);
}

export function buildStatsLoginCTA(): HTMLElement {
  return buildLoginCTA({
    title: "내 기록을 보려면 로그인해주세요",
    hint: "승률, 월별 추이, 자주 뛴 파트너 같은 통계는 본인 PIN으로 로그인한 후에 볼 수 있어요.",
  });
}
